import React, { useState } from 'react';

const MultiChipFilters = ({ allTags, allCountries, allCategories, onApplyFilters }) => {
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [selectedSubcategories, setSelectedSubcategories] = useState([]);

  const handleTagToggle = (tag) => {
    setSelectedTags(prev =>
      prev.includes(tag) ? prev.filter(t => t !== tag) : [...prev, tag]
    );
  };

  const handleCountryToggle = (country) => {
    setSelectedCountries(prev =>
      prev.includes(country) ? prev.filter(c => c !== country) : [...prev, country]
    );
  };

  const handleSubcategoryToggle = (subcategory) => {
    setSelectedSubcategories(prev =>
      prev.some(s => s.name === subcategory.name && s.categoryId === subcategory.categoryId)
        ? prev.filter(s => !(s.name === subcategory.name && s.categoryId === subcategory.categoryId))
        : [...prev, subcategory]
    );
  };

  return (
    <div className="space-y-4">
      <div>
        <p className="font-medium mb-1">Tags</p>
        <div className="flex flex-wrap gap-2">
          {allTags.map(tag => (
            <span
              key={tag}
              onClick={() => handleTagToggle(tag)}
              className={`px-2 py-1 rounded-full text-sm cursor-pointer ${selectedTags.includes(tag)
                ? 'bg-blue-600 text-white'
                : 'bg-gray-100 text-gray-700'}`}
            >
              {tag}
            </span>
          ))}
        </div>
      </div>

      <div>
        <p className="font-medium mb-1">Countries</p>
        <div className="flex flex-wrap gap-2">
          {allCountries.map(country => (
            <span
              key={country}
              onClick={() => handleCountryToggle(country)}
              className={`px-2 py-1 rounded-full text-sm cursor-pointer ${selectedCountries.includes(country)
                ? 'bg-green-600 text-white'
                : 'bg-gray-100 text-gray-700'}`}
            >
              {country}
            </span>
          ))}
        </div>
      </div>

      <div>
        <p className="font-medium mb-1">Categories & Subcategories</p>
        {allCategories.map(cat => (
          <div key={cat._id} className="mb-2">
            <p className="text-sm font-semibold">{cat.name}</p>
            <div className="flex flex-wrap gap-2 mt-1 ml-2">
              {cat.subcategories.map(sub => (
                <span
                  key={sub.name}
                  onClick={() => handleSubcategoryToggle({ name: sub.name, categoryId: cat._id })}
                  className={`px-2 py-1 rounded-full text-xs cursor-pointer ${selectedSubcategories.some(
                    s => s.name === sub.name && s.categoryId === cat._id)
                    ? 'bg-purple-600 text-white'
                    : 'bg-gray-100 text-gray-700'}`}
                >
                  {sub.name}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>

      <button
        onClick={() => onApplyFilters({ tags: selectedTags, countries: selectedCountries, subcategories: selectedSubcategories })}
        className="bg-blue-600 text-white px-4 py-2 rounded"
      >
        Apply Filters
      </button>
    </div>
  );
};

export default MultiChipFilters;
